import cafe2 from '../../assets/projects/cafe_page.png'
import satosaFed from '../../assets/projects/sunet_page.png'
import iam from '../../assets/projects/iam_page.png'
import workcoffee from '../../assets/projects/workcoffee_page.png';
import ihmB from '../../assets/projects/ihm_layout.png';

import lumens from '../../assets/projects/lumens_page.png';
import palabrariaB from '../../assets/projects/palabraria_layout.png';

import catchbeer from '../../assets/projects/catchbeer_page.png';

import modernSpace from '../../assets/projects/modernspace_page.png';
import colorAnalistB from '../../assets/projects/colorAnalist_layout.png';


const listProj = 
[
    {
        name: "CAFE 2.0",
        tag: "BACK END",
        describe: "O CAFE 2.0 É UMA SOLUÇÃO DE MODERNIZAÇÃO DA INFRAESTRUTURA DE AUTENTICAÇÃO DA COMUNIDADE ACADÊMICA FEDERADA, QUE CONECTA INSTITUIÇÕES BRASILEIRAS. O PROJETO IMPLEMENTA O PROTOCOLO OPENID FEDERATION 1.0 PARA AMPLIAR O ALCANCE DA REDE FEDERADA E PERMITIR INTEROPERABILIDADE COM EDUGAIN",
        describeEn: "CAFE 2.0 IS A MODERNIZATION SOLUTION FOR THE AUTHENTICATION INFRASTRUCTURE OF FEDERATED ACADEMIC COMMUNITY, WHICH CONNECTS BRAZILIAN INSTITUTIONS. THE PROJECT IMPLEMENTS THE OPENID FEDERATION 1.0 PROTOCOL TO EXPAND THE REACH OF THE FEDERATED NETWORK AND ENABLE INTEROPERABILITY WITH EDUGAIN",
        site: "https://gt-baita.ifrs.edu.br/",
        repository: "",
        more: ["PYTHON", "OPENID FEDERATION", "SAML2", "OIDC", "DOCKER", "RESTFULL", "JWT"],
        img: cafe2,
    },
    {
        name: "SATOSA-FEDERATION",
        tag: "BACK END",
        describe: "O SATOSA FEDERATION É UM FORK DO PROXY SATOSA, ADAPTADO PARA IMPLEMENTAR UM FRONTEND OPENID FEDERATION 1.0. A PRINCIPAL CONTRIBUIÇÃO FOI TRANSFORMAR O COMPORTAMENTO DE SINGLE TENANT PARA MULTITENANT, PERMITINDO QUE MÚLTIPLAS FEDERAÇÕES (TRUST ANCHORS) OPEREM SIMULTANEAMENTE NO MESMO PROXY",
        describeEn: "SATOSA FEDERATION IS A FORK OF THE SATOSA PROXY, ADAPTED TO IMPLEMENT AN OPENID FEDERATION 1.0 FRONTEND. THE MAIN CONTRIBUTION WAS TRANSFORMING THE BEHAVIOR FROM SINGLE TENANT TO MULTITENANT, ALLOWING MULTIPLE FEDERATIONS (TRUST ANCHORS) TO OPERATE SIMULTANEOUSLY ON THE SAME PROXY",
        site: "",
        repository: "https://github.com/alisonnRB/satosa-federation",
        more: ["PYTHON", "SAML2", "OIDC", "OPENID FEDERATION", "DOCKER", "RESTFULL", "JWT"],
        img: satosaFed,
    },
    {
        name: "IAM-PROXY-ITALIA",
        tag: "BACK END",
        describe: "O IAM PROXY ITALIA É UM FORK DO PROXY OFICIAL DO GOVERNO ITALIANO, ADAPTADO PARA TRANSFORMAR SEU COMPORTAMENTO DE SINGLE TENANT PARA MULTITENANT. IMPLEMENTA TRADUÇÃO DE PROTOCOLOS COMO SAML2, OIDC E OPENID4VC, E ADAPTA METADADOS PARA AUTENTICAÇÃO COM SPID, CIE, EIDAS E WALLET DIGITAL",
        describeEn: "IAM PROXY ITALIA IS A FORK OF THE OFFICIAL ITALIAN GOVERNMENT PROXY, ADAPTED TO TRANSFORM ITS BEHAVIOR FROM SINGLE TENANT TO MULTITENANT. IT IMPLEMENTS PROTOCOL TRANSLATION LIKE SAML2, OIDC AND OPENID4VC, AND ADAPTS METADATA FOR AUTHENTICATION WITH SPID, CIE, EIDAS AND DIGITAL WALLET",
        site: "",
        repository: "https://github.com/alisonnRB/iam-proxy-italia",
        more: ["PYTHON", "SAML2", "OIDC", "OPENID4VC", "DOCKER", "RESTFULL", "HASH"],
        img: iam,
    },
    {
        name: "WORK COFFEE",
        tag: "FRONT END",
        describe: "O WORKCOFFEE É UMA CAFETERIA COM MODELO DE NEGÓCIO ÚNICO, ONDE OS CLIENTES PAGAM PELO TEMPO DE USO DO ESPAÇO, IDEAL PARA TRABALHAR E ESTUDAR. COM WI-FI DE ALTA VELOCIDADE E BEBIDAS DE QUALIDADE",
        describeEn: "WORKCOFFEE IS A COFFEE SHOP WITH A UNIQUE BUSINESS MODEL, WHERE CUSTOMERS PAY FOR THE TIME THEY USE THE SPACE, IDEAL FOR WORKING AND STUDYING. WITH HIGH-SPEED WI-FI AND QUALITY BEVERAGES",
        site: "https://work-coffee.vercel.app/",
        repository: "https://github.com/alisonnRB/Work-Coffee",
        more: ['NEXT.JS', "REACT", "TAILWIND CSS", "JAVASCRIPT", "HTML", "CSS"],
        img: workcoffee,
    },
    {
        name: "IHM-SERVER",
        tag: "BACK END",
        describe: "O IHM SERVER É UM SERVIDOR DESENVOLVIDO PARA ADMINISRAR AS INFORMAÇÔES DO PROJETO IHM, UMA REDE SOCIAL LITERARIA QUE PERMITE A INTERAÇÃO ENTRE OS LEITORES E ESCRITORES, PERMITINDO A CRIAÇÃO DE LIVROS, POSTS E CHATS.",
        describeEn: "IHM SERVER IS A SERVER DEVELOPED TO MANAGE INFORMATION FROM THE IHM PROJECT, A LITERARY SOCIAL NETWORK THAT ALLOWS INTERACTION BETWEEN READERS AND WRITERS, ALLOWING THE CREATION OF BOOKS, POSTS AND CHATS.",
        site: "",
        repository: "https://github.com/alisonnRB/Server-IHM",
        more: ["PHP", "SQL", "RESTFULL", "WEBSOCKET", "TOKEN AUTH", "GOOGLE AUTH", "HASH"],
        img: ihmB,
    },
    {
        name: "LUMENS",
        tag: "FRONT END",
        describe: "LUMENS É O PORTFÓLIO DE DUAS IRMÃS FOTÓGRAFAS, COM UM DESIGN ELEGANTE E MODERNO, GALERIA INTERATIVA, SEÇÃO SOBRE E INFORMAÇÕES DE CONTATO. DESENVOLVIDO PARA UMA EXPERIÊNCIA DINÂMICA E RESPONSIVA",
        describeEn: "LUMENS IS THE PORTFOLIO OF TWO SISTER PHOTOGRAPHERS, WITH AN ELEGANT AND MODERN DESIGN, INTERACTIVE GALLERY, ABOUT SECTION AND CONTACT INFORMATION. DEVELOPED FOR A DYNAMIC AND RESPONSIVE EXPERIENCE",
        site: "https://lumen-rho.vercel.app/",
        repository: "https://github.com/alisonnRB/Lumen",
        more: ["NEXT.JS", "REACT", "TAILWIND CSS", "JAVASCRIPT", "HTML", "CSS"],
        img: lumens,
    },
    {
        name: "PALABRARIA SERVER",
        tag: "BACK END",
        describe: "O PALABRARIA SERVER É UM SERVIDOR PROJETO PARA CATALOGAR E GERENCIAR AS PALAVRAS DO DICIONÁRIO PALABRIA, RESPONSAVEL POR GERENCIAR A HIERARQUIA DE MODERAÇÃO",
        describeEn: "THE PALABRARIA SERVER IS A SERVER DESIGNED TO CATALOG AND MANAGE THE WORDS IN THE PALABRARIA DICTIONARY, RESPONSIBLE FOR MANAGING THE MODERATION HIERARCHY",
        site: "",
        repository: "https://github.com/alisonnRB/Palabraria-server-POO",
        more: ["PHP", "SQL", "POO", "RESTFULL", "TOKEN AUTH", "HASH"],
        img: palabrariaB,
    },
    {
        name: "CATCH BEER",
        tag: "FRONT END",
        describe: "CATCH BEER É UM SITE DE DELIVERY DE BEBIDAS COM CATÁLOGO DIVERSIFICADO, DESIGN INTUITIVO E NAVEGAÇÃO FÁCIL, OFERECENDO UMA EXPERIÊNCIA PRÁTICA E EFICIENTE PARA OS AMANTES DE BEBIDAS",
        describeEn: "CATCH BEER IS A BEVERAGE DELIVERY WEBSITE WITH A DIVERSE CATALOG, INTUITIVE DESIGN AND EASY NAVIGATION, OFFERING A PRACTICAL AND EFFICIENT EXPERIENCE FOR BEVERAGE LOVERS",
        site: "https://catche-beer.vercel.app/",
        repository: "https://github.com/alisonnRB/catche-beer",
        more: ["NEXT.JS", "REACT", "TAILWIND CSS", "JAVASCRIPT", "HTML", "CSS"],
        img: catchbeer,
    },
    {
        name: "MODERN SPACE",
        tag: "FRONT END",
        describe: "MODERN SPACE É UM SITE DE APRESENTAÇÃO PARA UMA LOJA DE MÓVEIS PLANEJADOS E MODULADOS, COM DESIGN MODERNO E ELEGANTE, EXIBINDO PRODUTOS SOFISTICADOS, CATEGORIAS E PROMOÇÕES",
        describeEn: "MODERN SPACE IS A PRESENTATION WEBSITE FOR A FURNITURE STORE WITH CUSTOM AND MODULAR FURNITURE, WITH MODERN AND ELEGANT DESIGN, SHOWCASING SOPHISTICATED PRODUCTS, CATEGORIES AND PROMOTIONS",
        site: "https://modern-space-zeta.vercel.app/",
        repository: "https://github.com/alisonnRB/Modern-Space",
        more: ["NEXT.JS", "REACT", "TAILWIND CSS", "JAVASCRIPT", "HTML", "CSS"],
        img: modernSpace,
    },
    {
        name: "COLOR-ANALIST API",
        tag: "BACK END",
        describe: "O PROJETO COLO-ANALIST É UMA API CAPAZ DE IDENTIFICAR CORES E PALETAS DE UMA IMAGEM E RETONAR SEUS VALORES HRX E RGB PARA SER UTILIZADO EM DESIGNS MAIS CUSTOMIZADOS DE PÁGINAS WEB.",
        describeEn: "THE COLO-ANALIST PROJECT IS AN API CAPABLE OF IDENTIFYING COLORS AND PALETTES OF AN IMAGE AND RETURNING THEIR HRX AND RGB VALUES TO BE USED IN MORE CUSTOMIZED WEB PAGE DESIGNS.",
        site: "",
        repository: "https://github.com/alisonnRB/Color-Analist-laravel",
        more: ["LARAVEL", "PHP", "RESTFULL", "POO"],
        img: colorAnalistB,
    },
];

export {listProj};
